import React from 'react';

const UserSVG = () => (
  <svg fill="#000000" x="0px" y="0px" viewBox="0 0 75 100">
    <path d="M37.5,50C16.797,50,0,66.797,0,87.5C0,94.409,5.591,100,12.5,100h50c6.909,0,12.5-5.591,12.5-12.5  C75,66.797,58.203,50,37.5,50z" fill="#000000" />
    <path d="M56.25,18.75c0,10.352-8.398,18.75-18.75,18.75s-18.75-8.398-18.75-18.75S27.148,0,37.5,0  S56.25,8.398,56.25,18.75z" fill="#000000" />
  </svg>
);

export default UserSVG;
